import { MainPadding } from "../../../styles/Main.styles";
import { useState } from "react";
import TableHeader from "../../../components/table/TableHeader";
import { useNavigate } from "react-router";
import TableFC, {
  TableFCBodyProps,
  TableHeadProps,
} from "../../../components/table/Table";
import { useGetBrands } from "../../produk/api/product/brand/resolver";
import useTableProperties from "../__component/table/TableProperties";
import { IconOnButton } from "../../../components/button/Button";
import ImportExportIcon from "@mui/icons-material/ImportExport";

export default function Main() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [keyword, setKeyword] = useState<string>();
  const { data: dataRawBrands, isLoading: loadingFetchSupplier } = useGetBrands(
    { page: page, keyword: keyword }
  );
  const dataBrand = dataRawBrands?.data.data.data;
  const header: TableHeadProps[] = [{ title: "No" }, { title: "Nama" }];
  const body: TableFCBodyProps[] = [{ key: "brand_name" }];
  const { renderRight } = useTableProperties();

  return (
    <MainPadding>
      <TableHeader
        addButton
        onClickAdd={() => navigate("/brand/creation")}
        renderRight={renderRight()}
        filterLabel="Search Brand"
        onSearch={(e) => setKeyword(e)}
        searchBar
        renderRightButton={
          <IconOnButton
            text="Import/Export"
            icon={<ImportExportIcon />}
            handleClick={() => {}}
          />
        }
      />
      <TableFC
        loading={loadingFetchSupplier}
        data={dataBrand}
        body={body}
        showIndex
        totalRows={dataRawBrands?.data.data.total}
        perColumns={perPage}
        onPerPageChange={(e) => setPerPage(e)}
        head={header}
        onPageChange={(e) => setPage(e)}
        onCellClick={(e) => navigate(`/brand/creation/${e.id}`)}
      />
    </MainPadding>
  );
}
